module.exports = __webpack_public_path__ + "img/totalSec.66232ecc.svg";